const topbar = {
    docs: 'Документы',
    help: 'Помощь',
    /** UNTRANSLATED */
    subscription: 'Subscription',
};
export default Object.freeze(topbar);
